import React from 'react';
import { Link } from 'react-scroll';
import css from './Categories.module.scss';

const Categories = ({ onClick, categories }) => {
    return (
        <Link
            activeClass={css.faqCategoriesWrapLinkActiv}
            to={categories.anchorId}
            spy={true}
            smooth={true}
            onSetActive={() => {
                onClick(categories.anchorId);
            }}
            offset={-350}
            duration={500}
        >
            <div
                onClick={(id) => onClick(id)}
                className={categories.isActive ? css.faqCategoriesWrapActiv : css.faqCategoriesWrap}
            >
                <p className={categories.isActive ? css.faqCategoriesActivName : css.faqCategoriesName}>{categories.name}</p>
            </div>
        </Link>
    );
};
export default Categories;
